import { useState } from "react";
import { WEB3FORMS_ACCESS_KEY } from "../config/web3forms";

export function useWeb3Form(source) {
  const [result, setResult] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    if (!WEB3FORMS_ACCESS_KEY) {
      setResult("Form is not configured. Please try again later.");
      return;
    }

    setSubmitting(true);
    setResult("");

    const formData = new FormData(event.target);
    formData.append("access_key", WEB3FORMS_ACCESS_KEY);
    formData.append("subject", `Awa Digital — ${source}`);
    formData.append("from_page", source);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();

      if (data.success) {
        setResult("Thanks. We'll be in touch shortly.");
        event.target.reset();
      } else {
        setResult("Something went wrong. Please try again.");
      }
    } catch {
      setResult("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return { onSubmit, result, submitting };
}
